module.exports = __webpack_public_path__ + "static/media/PayPal.001a1bda.svg";